/* eslint-disable camelcase */

// See Abstract:
// https://app.abstract.com/projects/c281163f-3311-4949-b3de-cf103894cbbd/branches/master/commits/b8bbc889a3919f31dc68e9cf0fb08244ba34fc46/files/c0e0b52b-5bc4-47f4-98b2-bc53cf09b312/layers/E3A415C1-73B5-42FB-922B-BCAE8F7DBC49?collectionId=03fedf67-562a-4ff8-965c-11f2c637d53e&collectionLayerId=18737750-8997-452e-b0e8-1ad06dd683fb&mode=build
// https://zeroheight.com/3b180e2fe/p/58b2c0-colors

export interface ColorPalette {
  white: string;
  black: string;
  transparent: string;

  // took these names from https://www.color-name.com/
  eerie_black: string;
  dark_charcoal: string;
  blueberry: string;

  blue_10: string;
  blue_20: string;
  blue_30: string;
  blue_50: string;
  blue_55: string;
  blue_60: string;

  blue_gray_50: string;
  blue_gray_70: string;

  gray_05: string;
  gray_10: string;
  gray_20: string;
  gray_30: string;
  gray_40: string;
  gray_50: string;
  gray_70: string;
  gray_90: string;

  green_10: string;
  green_30: string;
  green_50: string;

  orange_30: string;
  orange_50: string;
  orange_55: string;
  orange_70: string;

  red_10: string;
  red_30: string;
  red_50: string;
  red_90: string;

  yellow_50: string;
}

const colors: ColorPalette = {
  white: '#ffffff',
  black: '#000000',
  eerie_black: '#1F1F1F',
  dark_charcoal: '#333231',
  transparent: 'transparent',
  blueberry: '#4DBFFF',

  blue_10: '#ebf0f5', // extra light blue
  blue_20: '#e6ebef', // light blue
  blue_30: '#c0ccd7', // medium blue
  blue_50: '#2277bc', // pill blue
  blue_55: '#4067ba', // link blue
  blue_60: '#6098C4', // Blob

  blue_gray_50: '#7a9caf', // cp blue
  blue_gray_70: '#4c4c4c', // cp dark gray

  gray_05: '#f7f7f7', // faint gray: Used for background of content area
  gray_10: '#ededed', // extra light gray
  gray_20: '#d9d9d9', // light gray
  gray_30: '#bfbfbf', // medium light gray
  gray_40: '#949494', // gray
  gray_50: '#757575', // medium gray / text
  gray_70: '#4c4c4c', // dark gray / text
  gray_90: '#292929', // black gray / text

  green_10: '#c9f3a5', // light green / notification / toast
  green_30: '#69BB42', // Blob
  green_50: '#3c8300', // medium green / pill / status

  orange_30: '#e3b28c', // light orange
  orange_50: '#ff7a14', // cp orange
  orange_55: '#f06800', // medium orange / primary button
  orange_70: '#a84900', // dark orange

  red_10: '#fff2f0', // light red / notification / toast
  red_30: '#FFA3A3', // light red / dark mode fg
  red_50: '#d12a11', // medium red / pill / status
  red_90: '#371d19', // dark red bg

  yellow_50: '#fcb315', // medium gold / pill / status
};

export default colors;
